import * as f from '../../../components/BPMTable/BPMInputs'
import {
    DataMapper,
    DataTransformer,
    OnlyFilterActionDisplayStrategy,
    TableFieldDescription,
    StatusChipComponentCreator,
    ProcessControlTasksComponentCreator,
    DateTimeComponentCreator,
    DateTimeDisplayCreator,
    MultilineComponentCreator,
} from '../../../components/BPMTable/TableMapperCreator'
import {ExportFooterItemCreator} from "../../../components/BPMTable/TableFooterItems"
import PopupContent from '../../../pages/Jobs/Process/PopupContent'
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import { DirectTableQueryBuilder } from "../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder"
import { checkProcessDuration } from '../../../utils/processControlUtils'

let editMutator

let newMutator

let deleteMutator

const unitQuery = `
    processControl(id: $id) {
        id
        state
        user {
            id
            email
            enterpriseId
        }
        createdAt
        updatedAt
        totalCount
        currentCount
        modelClassName
        message
        subProcesses {
            taskName
            state
            createdAt
            updatedAt
            message
        }
    }
`

const queries = {tableQueryBuilder: new DirectTableQueryBuilder('allProcessControls'), editMutator, newMutator, deleteMutator, unitQuery}

class JobsProcessTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "JobsProcessTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator =  this.createTableCreator(this.constructor.getId(), tableName, queries)
        tableCreator.setDisplayStrategy(new OnlyFilterActionDisplayStrategy())
        tableCreator.setTableFooterItems([new ExportFooterItemCreator()]);

        tableCreator.setInitialSortField('createdAt', 'desc')
        tableCreator.addDescriptions ([
            new TableFieldDescription(
                'user',
                new DataMapper("user.enterpriseId"),
                new f.FilterDescription(new f.TextFilter("user")),
                {label: 'User'}

            ),
            new TableFieldDescription(
                'state',
                new DataMapper("state"),
                new f.FilterDescription(new f.ProcessControlStateFilter("state")),
                {label: 'State', componentCreator: new StatusChipComponentCreator()}
            ),
            new TableFieldDescription(
                'modelClassName',
                new DataMapper("modelClassName"),
                new f.FilterDescription(new f.NullCreator()),
                {label: 'Table', hideSort: true}
            ),
            new TableFieldDescription(
                'createdAt',
                new DataMapper("createdAt"),
                new f.FilterDescription(new f.PeriodFilter("createdAt")),
                {
                    label: 'Creation Date',
                    componentCreator: new DateTimeComponentCreator(),
                    excelDisplay: new DateTimeDisplayCreator()
                }
            ),
            new TableFieldDescription(
                'updatedAt',
                new DataMapper("updatedAt"),
                new f.FilterDescription(new f.PeriodFilter("updatedAt")),
                {
                    label: 'Updated at',
                    componentCreator: new DateTimeComponentCreator(),
                    excelDisplay: new DateTimeDisplayCreator()
                }
            ),
            new TableFieldDescription(
                'duration',
                new DataMapper("duration", "createdAt", "updatedAt", "state"),
                new f.FilterDescription(new f.NullCreator()),
                {label: 'Duration', transform: new DataTransformer(({duration, createdAt, updatedAt, state}) => checkProcessDuration(duration, createdAt, updatedAt, state)), hideSort: true}
            ),
            new TableFieldDescription(
                'totalCount',
                new DataMapper("totalCount"),
                new f.FilterDescription(new f.NullCreator()),
                {label: 'Total count', hideSort: true, fieldAlign: 'right'}
            ),
            new TableFieldDescription(
                'currentCount',
                new DataMapper("id", "totalCount", "currentCount", "subProcesses","subProcesses.taskName", "subProcesses.state", "subProcesses.createdAt", "subProcesses.updatedAt", "subProcesses.message"),
                new f.FilterDescription(new f.NullCreator()),
                {
                    label: 'Current count',
                    componentCreator: new ProcessControlTasksComponentCreator(PopupContent),
                    transform: new DataTransformer(({id, totalCount, currentCount, subProcesses}) => ({processControlId: id, total: totalCount, count: currentCount, tasks: subProcesses})),
                    hideSort: true,
                    fieldAlign: 'right'
                }
            ),
            new TableFieldDescription(
                'message',
                new DataMapper("message"),
                new f.FilterDescription(new f.TextFilter('message')),
                {
                    label: 'Message',
                    onlyForm: true,
                    hideSort: true,
                    componentCreator: new MultilineComponentCreator(),
                }
            ),
        ]);

        return tableCreator;
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(JobsProcessTableCreator)

export default JobsProcessTableCreator;
